import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { useEffect, useState } from 'react';
import { useBoundStore } from 'useStore';
import useDebounce from 'hooks/useDebounce';

export default function SearchBar() {
	const search = useBoundStore((state) => state.productMasterSearch);
	const setSearch = useBoundStore((state) => state.setProductMasterSearch);
	const [searchField, setSearchField] = useState('');
	const debouncedSearchField = useDebounce(searchField, 500);

	useEffect(() => {
		setSearch(debouncedSearchField);
	}, [debouncedSearchField, setSearch]);

	useEffect(() => {
		if (search === '') {
			setSearchField('');
		}
	}, [search]);

	return (
		<TextField
			placeholder="SKU"
			label="Buscar"
			value={searchField}
			onChange={(e) => setSearchField(e.target.value)}
			sx={{
				'& .MuiOutlinedInput-notchedOutline': {
					borderRadius: '5px',

					border: '1px solid #0000003B',
				},
				'& .MuiInputBase-input': {
					backgroundColor: '#FFFFFF',
				},
				'& .MuiInputBase-root': {
					backgroundColor: '#FFFFFF',
				},
				width: { xs: '150px', sm: '200px', md: '300px' },
			}}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon fontSize="small" />
					</InputAdornment>
				),
			}}
		/>
	);
}
